import { CancelButton, EditButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { TextLabel } from '@core/components/Inputs';
import DateLabel from '@core/components/Inputs/DateLabel';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Grid } from '@material-ui/core';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useContext } from 'react';
import { FaCreditCard } from 'react-icons/fa';
import { ContaContext } from '../../../ContaContext';
import { modaisConta } from '../modais';
import { contaModalStyles } from '../modalStyles';

const VisualizarContaCaixinhaModal = () => {
  const [modal, setModal] = useContext(ContaContext).modal;
  const [conta] = useContext(ContaContext).contaAtual;

  const modalStyles = contaModalStyles();

  const handleCloseModal = () => {
    setModal(false);
  };

  const handleOpenEditMode = () => {
    setModal(modaisConta.editarContaCaixinha);
  };

  const Content = () => {
    return (
      <div className={modalStyles.container}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="descricao" label="Descrição" value={conta?.descricao} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="saldoInicial"
              label="Saldo Inicial (R$)"
              value={getCurrency(conta?.contaCaixinha?.saldoInicial)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <DateLabel id="dataSaldoInicial" label="Data do saldo" value={conta?.contaCaixinha?.dataSaldo} />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={12} xl={12}>
            <DateLabel
              id="dataEncerramento"
              label="Data do encerramento"
              value={conta?.contaCaixinha?.dataEncerramento}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <SimpleDialog open={modal === modaisConta.visualizarContaCaixinha} onClose={handleCloseModal}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de conta caixinha',
          icon: <FaCreditCard />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>
              {permissaoUtils.conta().editar && (
                <EditButton id="add-classe-root" type="submit" onClick={handleOpenEditMode}>
                  Editar
                </EditButton>
              )}
            </>
          ),
        }}
        content={<Content />}
      />
    </SimpleDialog>
  );
};

export default VisualizarContaCaixinhaModal;
